import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import {
  isChatSpace,
  isCourseSpace,
  isEventsSpace,
} from "@circle-react/helpers/spaceHelpers";
import { PageLoader } from "@circle-react/pages/PageLoader";
import type { Space } from "@circle-react/types/Space";

export interface SpaceContentProps {
  space?: Space;
}

const CourseSpaceComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "CourseSpaceComponent" */ "@circle-react/components/Spaces/CourseSpace"
    ),
);

const ChatSpaceComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "ChatSpaceComponent" */ "@circle-react/components/Spaces/ChatSpace"
    ),
);

const EventsSpaceComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "EventsSpaceComponent" */ "@circle-react/components/Spaces/EventsSpace"
    ),
);

const ShowSpaceComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "ShowSpaceComponent" */ "@circle-react/components/Spaces/Show"
    ),
);

export const SpaceContent = ({ space }: SpaceContentProps) => {
  if (isCourseSpace(space)) {
    return (
      <Suspense fallback={<PageLoader />}>
        <CourseSpaceComponent key={space?.id} />
      </Suspense>
    );
  }

  if (isChatSpace(space)) {
    return (
      <Suspense fallback={<PageLoader />}>
        <ChatSpaceComponent key={space?.id} />
      </Suspense>
    );
  }

  if (isEventsSpace(space)) {
    return (
      <Suspense fallback={<PageLoader />}>
        <EventsSpaceComponent key={space?.id} />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<PageLoader />}>
      <ShowSpaceComponent key={space?.id} />
    </Suspense>
  );
};

export default SpaceContent;
